import React from 'react';
import Modal from '../layout/modal';
import {Row, Col, Loader} from 'components';
import {Button} from 'components/layout';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import IntlWrapper from 'components/layout/intlWrapper';
import ReactDOM from 'react-dom';
import events from 'lib/events';
import Header from 'components/layout/header';
import session from 'services/sessionService';
import csvApi from 'api/csv';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import DeviceTools from 'page/tools/devices';
import AccountTools from 'page/tools/accounts';
import DatabaseTools from 'page/tools/database';

let render = (container) => {
  console.info('[UI.page.tools.calibration] rendering page');
  ReactDOM.render(<IntlWrapper><WrapperDatabaseUploadEmail /></IntlWrapper>, container);
  events.publish('page-change', {page: 'tools'});
};

console.info('[UI.page.tools.calibration] register route');
router.rr.add([{path: 'tools/uploadEmail', handler: routeUtils.requireAuth(render)}]);

class DatabaseUploadEmail extends React.Component {
  state = {
    errors: [],
    validating: true,
    modalConfirm: false,
    success: false,
    format: 'cust-only',
    sending: false,
    uploadEnabled: false,
  };

  enableUpload = () => {
    setTimeout(() => { // Delay 5 seconds since doesn't seem to register right away
      this.setState({
        uploadEnabled: true,
      });
    }, 500);
  };

  uploadFile = (saveChangesflag) => {
    let file = this.refs.csvFile.files[0];

    if (file) {
      this.setState({success: false, errors: [], sending: true, uploadEnabled: false});
      csvApi.uploadContacts(file, saveChangesflag)
        .then((res) => {
          if (saveChangesflag) {
            events.publish('success.user', {message: 'Upload Complete: ' + res.length + ' contacts updated.'});
            this.setState({success: true, errors: [], sending: false, modalConfirm: false});
          } else {
            this.setState({errors: [], sending: false, contacts: res, modalConfirm: true});
          }
        })
        .catch((response) => {
          if (response instanceof Array) {
            this.setState({errors: response.data, sending: false, uploadEnabled: true});
            events.publish('warn.user', {
              message:
  <span>
    <FormattedMessage id="tools.database.there.are" /> {response.data.length} <FormattedMessage id="tools.database.errors.uploaded" />
  </span>
              ,
            });
          } else {
            const {errors, csv: filepath} = response.data;

            this.setState({errors, sending: false, uploadEnabled: true});
            events.publish('warn.user', {
              message:
  <span>
    <FormattedMessage id="tools.database.there.are" /> {errors.length} <FormattedMessage id="tools.database.error.download" />
    <a className='btn btn-primary pull-right' href={'UploadCSV/DownloadErrors/?file=' + filepath}><FormattedMessage id="general.download" /></a>
  </span>
              ,
            });
          }
        });
    }
  };

  renderContactsToBeChanged = () => {
    if (this.state.contacts.length > 0) {
      return this.state.contacts.map((c,i) => {
        return <div key={i} className='contact'>
          <FormattedMessage id="tools.database.updating" /> {c.Phone} <FormattedMessage id="tools.database.email.to" /> {c.Email}
        </div>;
      });
    } else {
      return '';
    }
  };

  render() {
    let {formatMessage} = this.props.intl;
    let subPages = {
      devices: {name: formatMessage({id: 'general.devices'}), element: <DeviceTools />, permissionLevel: 1000},
      accounts: {name: formatMessage({id: 'general.accounts'}), element: <AccountTools />, permissionLevel: 2000},
      database: {name: formatMessage({id: 'general.database'}), element: <DatabaseTools />, permissionLevel: 3000},
    };

    let subPagesTabs = Object.keys(subPages)
      .filter(sp => subPages[sp].permissionLevel <= session.getUser().privileges.level)
      .map(sp => <a key={sp} className={sp === 'database' ? 'active' : ''}
                     href={'#tools/' + sp}>{subPages[sp].name}
      </a>);

    return (
      <div className='upload-page container'>
        {this.state.modalConfirm ?
          <Modal onClose={() => { }}>
            <div className='container'>
              <div className='row'>
                <div className='col-xs-12 adjust-margin'>
                  <div className='title'>
                    <FormattedMessage id="general.confirmation" />
                  </div>
                  <div>
                    {this.renderContactsToBeChanged()}
                    <div className='message'><FormattedMessage id="tools.database.above.contacts" /></div>
                    <div className='warning'>  <i className='bl bl-attention'/> <FormattedMessage id="tools.update.cannot.undone" /> </div>
                  </div>
                  <div className='btn-section'>
                    <button type='button'
                      className='btn btn-primary pull-right'
                      onClick={this.uploadFile.bind(this, true)}>
                      <FormattedMessage id="general.confirm" />
                    </button>
                    <button type='button'
                      className='btn btn-primary pull-right cancel'
                      onClick={() => {
                        this.setState({
                          modalConfirm: false,
                          uploadEnabled: true,
                        });
                      }}>
                      <FormattedMessage id="general.cancel" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal> :
          ''}
        <Header mainTitle={formatMessage({id: 'tools.title'})} subTitle={formatMessage({id: 'tools.database.email.append'})} mainTitleReturn='tools' />
        <nav className='navigation-tabs'>
          {subPagesTabs}
        </nav>
        <div className='row'>
          <div className='col-sm-12'>
            <h2><FormattedMessage id="tools.database.email.append" /></h2>
            <p className='b'><FormattedMessage id="tools.database.upload.list " /></p>
            <div className='form-group'>
              <Row>
                <Col sm={4}>
                  <input type='file' ref='csvFile' className='pull-left' style={{margin: '3px 10px 0px 0px'}}
                    onChange={this.enableUpload} />
                  <br />
                  <i><FormattedMessage id="tools.database.required.format" />: csv</i>
                </Col>
                <Col sm={4}>
                  <Button primary onClick={this.uploadFile.bind(this, false)}
                    style={{marginTop: 20}} disabled={!this.state.uploadEnabled}><FormattedMessage id="general.upload" /></Button>
                </Col>
              </Row>
            </div>
            <Loader loaded={!this.state.sending}>
              <div className='well'>
                <p>
                  <FormattedMessage id="tools.database.referencing.example" />
                </p>
                <div className='indent-example'>
                  <Row>
                    <Col sm={3} >
                      <strong> <FormattedMessage id="general.example" />:</strong>
                    </Col>
                    <Col sm={3}>
                      <strong><FormattedMessage id="general.phone" /></strong>
                      <div>
                        430-913-0298
                      </div>
                      <div>
                        549-394-0090
                      </div>
                    </Col>
                    <Col sm={3}>
                      <strong><FormattedMessage id="general.email" /></strong>
                      <div>
                        hf@gmail.com
                      </div>
                      <div>
                        julie@yahoo.com
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Loader>
            {this.state.success ?
              <div>
                {this.state.format === 'cust-only' ? <p className='b'><FormattedMessage id="tools.database.successful.upload" />!</p> : ''}
              </div> :
              ''
            }
            {this.state.errors.length > 0 ?
              <div>
                {this.state.errors.map((message,i) =>
                  <p key={i}><i className='fa fa-chevron-right'/> {message}</p>
                )}
              </div> :
              ''
            }
          </div>
        </div>
      </div>
    );
  }
}

let WrapperDatabaseUploadEmail = injectIntl(DatabaseUploadEmail);

export default WrapperDatabaseUploadEmail;
